import(/* webpackMode: "eager", webpackExports: ["GoogleOAuthProvider"] */ "/app/node_modules/@react-oauth/google/dist/index.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/sign-up/SignUpView.tsx");
